export default __webpack_public_path__ + "static/media/anna.b1cd9768.jpeg";